define(['clientComponents/googletagmanager/GtmProductPage',
        'clientComponents/googletagmanager/GtmListingPage',
        'clientComponents/googletagmanager/GtmEventTracker',
        'clientComponents/googletagmanager/GtmHomePage',
        'clientComponents/googletagmanager/GtmCommonPage',
        'clientComponents/googletagmanager/GtmFlightProductPage',
        'library/fcse-compatibility/object',
        'library/fcse-component/optionsMixin'],
    /**
     * @param {GtmProductPage} GtmProductPage
     * @param {GtmListingPage} GtmListingPage
     * @param {GtmEventTracker} GtmEventTracker
     * @param {GtmHomePage} GtmHomePage
     * @param {GtmCommonPage} GtmCommonPage
     * @param {GtmFlightProductPage} GtmFlightProductPage
     * @param Object
     * @param OptionsMixin
     * @returns {GtmManager}
     */
    function (GtmProductPage, GtmListingPage, GtmEventTracker, GtmHomePage,
              GtmCommonPage, GtmFlightProductPage, Object, OptionsMixin) {

        let instance = null;

        function GtmManager(){
            if(instance !== null){
                throw new Error("Cannot instantiate more than one GtmManager, use GtmManager.getInstance()");
            }

            this.initialize();
        }

        GtmManager.prototype = $.extend(Object.create(OptionsMixin), /** @lends GtmBase.prototype */{
            eventTracker: null,
            getInstance: function(){
                if(instance === null){
                    instance = new GtmManager();
                }
                return instance;
            },
            initialize: function () {},
            setOptions: function (options) {
                this.addOptions(options);
                const scope = this.option('scope');
                if (scope) {
                    scope.paramChange($.proxy(this._scopeParamChanged, this));
                }
                return this;
            },
            initPageTracker: function (pageType, options) {
                const trackerOptions = $.extend(this.getOptions(), options);
                switch (pageType) {
                    case 'productPage':
                        return new GtmProductPage(trackerOptions);
                        break;
                    case 'flightProductPage':
                        return new GtmFlightProductPage(trackerOptions);
                        break;
                    case 'homePage':
                        return new GtmHomePage(trackerOptions);
                        break;
                    case 'listingPage':
                        return new GtmListingPage(trackerOptions);
                        break;
                    case 'commonPage':
                        return new GtmCommonPage(trackerOptions);
                        break;
                }
            },
            initEventTracker: function (options) {
                this.eventTracker = new GtmEventTracker($.extend(this.getOptions(), options));
                return this.eventTracker;
            },
            _scopeParamChanged: function (event) {
                this.eventTracker._scopeParamChanged(event);
            }
        });

        GtmManager.getInstance = function(){
            if(instance === null){
                instance = new GtmManager();
            }
            return instance;
        };

        return GtmManager.getInstance();
    }
);



// WEBPACK FOOTER //
// ./src/Allt/FrontendBundle/Resources/assets/components/googletagmanager/GtmManager.js